export const projectStats = () => {
  const sectionName = document?.querySelector('.project-stats');
  const numbersEl = document?.querySelectorAll('.project-stats__count-number');

  /* eslint-disable */
  function animateValue(val, start, end, duration, isZeroBegins = false) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      val.innerHTML = (isZeroBegins ? '0' : '') + Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  if (sectionName) {
    const observerRoot = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          numbersEl.forEach((numberEl) => {
            const numberWrap = numberEl?.querySelector('span');
            const startValue = 0;
            const endValue = parseInt(numberEl.dataset.number, 10);

            if (endValue !== 0) {
              animateValue(numberWrap, startValue, endValue, 3000, Array.from(numberEl.dataset.number)[0] === '0');
            }
          });
          observer.unobserve(sectionName);
        }
      });
    });

    observerRoot.observe(sectionName);
  }
}


class TextAlignment {
    constructor()
    {
        this.projectStatsCounter = document.querySelectorAll('.project-stats__count--modern');
        this.projectStatsDescriptionClass = '.project-stats__count-text--modern';
        this.descriptionMaxHeight = 0;
    }

    listeners = () => {
        window.addEventListener('resize', this.changeHeight);
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
                this.changeHeight();
            }, 100);
        });
    };

    changeHeight = () => {
        this.projectStatsCounter.forEach(counter => {
            const descriptions = counter.querySelectorAll(this.projectStatsDescriptionClass);
            descriptions.forEach(description => {
                this.descriptionMaxHeight = Math.max(this.descriptionMaxHeight, description.offsetHeight);
            });
            descriptions.forEach(description => {
                description.style.height = `${this.descriptionMaxHeight}px`;
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=azds/project-stats', () => {
            projectStats();
        });
    } else {
        projectStats();
    }
});

const TextAlignmentObject = new TextAlignment();
TextAlignmentObject.listeners();
